/* eslint-disable operator-linebreak */
export const getOrderStatusTitle = status => {
  // получить текст статуса заявки
  switch (status) {
    case 1:
      return 'В обработке'
    case 2:
      return 'Подтверждена'
    case 3:
      return 'Лист ожидания'
    case 4:
      return 'Аннулирована'
    case 5:
      return 'Отклонена'
    default:
      return ''
  }
}

export const getOrderStatusColor = (status, isLocked) => {
  // получить цвет  по статусу заявки
  switch (status) {
    case 1:
      return 'order-status-new'
    case 2:
      if (isLocked === 1) {
        return 'order-status-accepted-blue'
      }

      return 'order_status-accepted-green'
    case 3:
      return 'order-status-waiting'
    case 4:
      return 'order-status-decline'
    case 5:
      return 'order-status-decline'
    default:
      return ''
  }
}

// --- служебные метки в примечании заявки -------------------------------------
//
// Метки, которые дописываются в примечание ДЛЯ ОПЕРАТОРА в офисе: групповая
// подача и экскурсия по спец. прайсу. Клиенту в графе «Пожелания» их показывать
// не надо — там его собственный текст. Живут метки в блоке «Добавила система»
// (его клиент не правит), но у заявок, поданных раньше, они остались в блоке
// «Клиент написал» — поэтому вырезаем их из обеих половин.
// «ШКОЛЬНАЯ ГРУППА» (12.10.2026) — галочка в форме заявки: по ней сайт считает
// оплату по школьному прайс-листу, а оператор видит, что группа школьная.
export const SCHOOL_NOTE_MARK = 'ШКОЛЬНАЯ ГРУППА'
export const SERVICE_NOTE_MARKS = ['ГРУППОВАЯ ЗАЯВКА', 'По спец прайсу.', SCHOOL_NOTE_MARK]

// Какие служебные метки стоят в тексте.
export const extractServiceMarks = text => {
  const src = String(text || '')

  return SERVICE_NOTE_MARKS.filter(mark => src.includes(mark))
}

// Код группы в примечании: «ГРУППОВАЯ ЗАЯВКА №ABCDEF». Ставится при отправке
// множественной заявки — один на все музеи одной группы. По нему список заявок
// на главной точно выделяет «эту» группу. Клиенту код не показываем.
const GROUP_CODE_RE = /ГРУППОВАЯ ЗАЯВКА(?:\s*№\s*([A-Za-zА-Яа-я0-9]+))?/

export const extractGroupCode = notes => {
  const m = String(notes || '').match(GROUP_CODE_RE)

  return m && m[1] ? m[1] : ''
}

// Заявка подана в групповом режиме?
export const isGroupNotes = notes => String(notes || '').includes('ГРУППОВАЯ ЗАЯВКА')

// Заявка на школьную группу?
export const isSchoolNotes = notes => String(notes || '').includes(SCHOOL_NOTE_MARK)

// Ref# заявки из групповой подачи: общий номер группы и через дефис порядковый
// номер музея в ней — 12345-1, 12345-2, 12345-3. Номер группы — то, что стоит
// до дефиса; по нему список заявок и выделяет «эту» группу.
//
// Дефис требуем строго перед числом в конце, иначе под правило попал бы обычный
// номер клиента вроде «группа 18-21.06».
const GROUP_REF_RE = /^(.{2,20})-(\d{1,3})$/

export const refNoBase = refno => {
  const m = String(refno || '').trim().match(GROUP_REF_RE)

  return m ? m[1] : ''
}

// Ключ группы для фильтра «показать только эту группу».
// Порядок: номер группы из Ref# (так подаются новые заявки) -> код в примечании
// (так подавались заявки 15–17.08.2026) -> связка гид+телефон+страна у совсем
// старых, где отличить одну группу от другой больше нечем.
export const groupKeyOf = data => {
  if (!data) return ''

  const base = refNoBase(data.refno)
  if (base) return `R:${base}`

  const code = extractGroupCode(data.notes)
  if (code) return `C:${code}`

  return `H:${data.guide || ''}|${data.guide_phone || ''}|${data.country_id || ''}`
}

// Метки, как они реально записаны в тексте (с кодом группы) — нужны, чтобы
// перенести их из клиентской половины примечания в системную, ничего не потеряв.
export const extractServiceMarksFull = text => {
  const src = String(text || '')
  const marks = []
  const group = src.match(GROUP_CODE_RE)
  if (group) marks.push(group[0].trim())
  if (src.includes('По спец прайсу.')) marks.push('По спец прайсу.')
  if (src.includes(SCHOOL_NOTE_MARK)) marks.push(SCHOOL_NOTE_MARK)

  return marks
}

// Текст без служебных меток (то, что реально написал клиент).
//
// Схлопываем только пробелы и табы, оставшиеся на месте вырезанной метки.
// Переносы строк не трогаем: раньше под «подряд идущие пробельные символы»
// попадал и перенос, поэтому многострочные пожелания клиента слипались в одну
// строку — и такими же сохранялись, если клиент открывал «Изменить».
export const stripServiceMarks = text => {
  // Сначала убираем код группы («№ABCDEF»), иначе он остался бы у клиента после
  // вырезания самой метки ниже.
  let out = String(text || '').replace(GROUP_CODE_RE, 'ГРУППОВАЯ ЗАЯВКА')
  SERVICE_NOTE_MARKS.forEach(mark => {
    out = out.split(mark).join(' ')
  })

  return out
    .replace(/[^\S\r\n]{2,}/g, ' ')
    .replace(/[^\S\r\n]+(\r?\n)/g, '$1')
    .trim()
}

// Собрать примечание заявки после правки пожеланий клиентом.
//
// Формат примечания: «Добавила система: … ### Клиент написал: …». Клиент правит
// только вторую половину, поэтому служебные метки должны лежать в первой. У
// заявок, поданных до этой правки, метки стоят во второй половине — переносим
// их в первую, иначе сохранение пожеланий стирало бы пометку, по которой
// работает оператор в офисе.
export const buildNotesWithUserText = (notes, userText) => {
  const parts = String(notes || '').split('###')
  const systemPart = parts[0]
  const clientPart = parts.slice(1).join('###')
  const legacyMarks = extractServiceMarksFull(clientPart).filter(mark => !systemPart.includes(mark))
  const system = [systemPart.trim(), ...legacyMarks].filter(Boolean).join(' ')

  return `${system} ### Клиент написал: ${String(userText || '').trim()}`
}

export const getQtyTotal = order => {
  // возвращает общее кол-во билетов в заказе
  // eslint-disable-next-line operator-linebreak
  const { notes } = order.data

  // Категории билетов, которых нет в самой заявке, система дописывает в блок
  // «Добавила система» строками «Название: N шт.» — их и собираем. Служебные
  // метки оттуда вырезаем: в коде группы бывают цифры, и они попадали бы в
  // количество людей.
  const correctString = stripServiceMarks(notes.substr(0, notes.indexOf('###')))
  const notesNumbersValues = correctString.match(/[0-9]+/g)
  let notesValue = 0
  if (notesNumbersValues) {
    notesValue = notesNumbersValues.reduce((acc, val) => Number(acc) + Number(val), 0)
  }
  const total =
    Number(order.data.qty_common) +
    Number(order.data.qty_privileged) +
    Number(order.data.qty_child) +
    Number(notesValue)

  return total
}

export const getGuideStr = request => {
  // возвращает значение сопровождающего гида
  let guideStr = 'Без сопр. гида'
  if (request.data.qty_guide > 0) {
    guideStr = `${request.data.qty_guide} сопр.`
  }

  return guideStr
}

// Дата в МЕСТНОМ времени как 'YYYY-MM-DD'.
//
// Через toISOString() брать нельзя: он отдаёт UTC, а мы на UTC+3. Ночью
// (00:00–03:00 по Москве) UTC-дата ещё вчерашняя, и «сегодня + 1 день»
// получалось сегодняшним числом — запрет «не раньше завтра» ночью пропускал
// заявку на сегодня. Календарь клиент видит в местном времени, значит и
// границы считаем в нём же.
export const toLocalDay = (date = new Date()) => {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${date.getFullYear()}-${month}-${day}`
}

// Самая ранняя дата, на которую принимается заявка по объекту: сегодня плюс
// срок подачи из админки (min_days_before). С неё же начинается календарь, и
// на неё ставим дату в форме — иначе клиент мог бы взять время на сегодня, не
// открывая календарь, и обойти запрет.
export const earliestRequestDate = museumObject => {
  const days = Number((museumObject && museumObject.min_days_before) || 0)
  const from = new Date()
  from.setDate(from.getDate() + days)

  return toLocalDay(from)
}

// Ref# — номер турфирмы, внешняя система его не генерит и ничего в нём не
// проверяет. Если клиент номер не ввёл, подставляем свой. Раньше это была метка
// времени в миллисекундах (13 цифр): в офисе колонка «Ref#» шириной 5em, и такой
// номер в неё не влезал. Теперь пять цифр.
//
// В базе офиса есть частичный уникальный индекс
// (фирма + Ref# + музей + дата, кроме аннулированных и отклонённых), поэтому
// повтор номера на тот же музей и день — отказ. Занятые номера отсеиваем.
const REF_FIRST = 10000
const REF_COUNT = 90000

export const makeRefNo = (taken = []) => {
  const busy = new Set((taken || []).map(String))
  for (let attempt = 0; attempt < 50; attempt += 1) {
    const candidate = String(REF_FIRST + Math.floor(Math.random() * REF_COUNT))
    if (!busy.has(candidate)) return candidate
  }

  // Случайные попытки не помогли — свободных номеров почти не осталось.
  // Идём подряд от случайного места, чтобы найти хоть один.
  const start = Math.floor(Math.random() * REF_COUNT)
  for (let i = 0; i < REF_COUNT; i += 1) {
    const candidate = String(REF_FIRST + ((start + i) % REF_COUNT))
    if (!busy.has(candidate)) return candidate
  }

  return String(REF_FIRST + Math.floor(Math.random() * REF_COUNT))
}

// Ref# отдельной заявки внутри группы: номер группы плюс её порядковый номер.
export const groupRefNo = (base, index) => `${String(base).trim()}-${index + 1}`

// Открыт ли клиенту китайский прайс-лист (шеф, 30.10.2026: китайцы и
// иностранцы разделены полностью). Признак приходит в данных пользователя
// (cn_pricing_enabled); без него категория «Китайские туристы» в формах не
// предлагается — китайскую группу подают как иностранную.
export const chineseGroupsOpen = () => {
  try {
    return !!JSON.parse(localStorage.getItem('userData') || '{}').cn_pricing_enabled
  } catch (e) {
    return false
  }
}

// Список категорий групп для формы: без китайской, если она клиенту не
// открыта. В китайском кабинете вместо неё — «иностранные туристы».
export const groupTypeChoices = (choices, fallbackForeign) => {
  if (chineseGroupsOpen()) return choices
  const rest = choices.filter(item => item.value !== 'cn')
  if (rest.length) return rest

  return fallbackForeign ? [fallbackForeign] : rest
}

export const getUserNotes = notes => {
  if (notes && notes.includes('Клиент написал:')) {
    return stripServiceMarks(notes.split('Клиент написал:')[1])
  }

return stripServiceMarks(notes)
}

export const getInfoFromNotesTickets = (notes, catergory) => {
  // возвращает доп информацию внесенную в заметки системой о билетах
  const removeBeforeValueString = notes.split(`${catergory}: `)[1]
  const valueString = removeBeforeValueString.split(' шт.')[0]

  return valueString
}

export const getInfoFromNotesServices = (notes, catergory) => {
  // возвращает доп информацию внесенную в заметки системой об услугах
  const removeBeforeValueString = notes.split(`${catergory}: `)[1].split('.')[0]
  if (removeBeforeValueString.includes('Да')) {
    return true
  }

  return false
}

// «Подача графика на октябрь 2026 закрывается 20.09.2026»: график на месяц M
// принимается до 20-го числа месяца M-1. Считаем от сегодняшней даты — фраза
// с годом, вписанным руками, провисела в форме с апреля 2024-го.
export const scheduleWindow = localeCode => {
  const now = new Date()
  const deadlineThisMonth = new Date(now.getFullYear(), now.getMonth(), 20, 23, 59, 59)
  const shift = now <= deadlineThisMonth ? 1 : 2
  const target = new Date(now.getFullYear(), now.getMonth() + shift, 1)
  const deadline = new Date(target.getFullYear(), target.getMonth() - 1, 20)
  const pad = value => String(value).padStart(2, '0')

  return {
    month: target.toLocaleDateString(localeCode, { month: 'long', year: 'numeric' }),
    deadline: `${pad(deadline.getDate())}.${pad(deadline.getMonth() + 1)}.${deadline.getFullYear()}`,
  }
}

// Экскурсионное обслуживание в заявке не вводится, а считается (шеф,
// 23.10.2026): одно на каждые persons_per_guide человек (норма музея у
// объекта) с округлением вверх — 40 человек при норме 15 это три. Нормы
// нет — одно на группу; людей нет — ноль. Правило «всегда одно на заявку»
// от 17.10.2026 отменено. Одна формула для формы заявки, групповой заявки
// и калькулятора цен, чтобы суммы совпадали.
export const guideServicesCount = (persons, perGuide) => {
  const people = Math.max(0, Math.trunc(Number(persons) || 0))
  if (people === 0) return 0
  const norm = Math.trunc(Number(perGuide) || 0)

  return norm > 0 ? Math.ceil(people / norm) : 1
}

// Суффикс полей с переводом («name_ru_RU») по языку кабинета.
const NAME_SUFFIX = {
  ru: '_ru_RU', en: '_en_US', zh: '_zh_cn', fa: '_fa_IR', vi: '_vi',
}

// Музеи по алфавиту на языке кабинета (шеф, 02.11.2026): в «Расчёте
// стоимости» и в формах заявок; порядок из админки больше не используется.
export const sortMuseumsByName = list => {
  const locale = localStorage.getItem('locale') || 'ru'
  const key = `name${NAME_SUFFIX[locale] || '_ru_RU'}`
  const title = museum => String((museum && (museum[key] || museum.name)) || '')

  return [...(list || [])].sort((a, b) => title(a).localeCompare(title(b), locale, { sensitivity: 'base' }))
}
